import Modal from '../../../../../components/ui/Modal';
import { BaseModalProps } from '../../../../../components/modals/ConfirmModal';
import { MetadataEditor } from '../../../../../components/ui/MetadataEditor';

function MetadataModal({
  onClose,
  open,
  metadata,
  photoId,
  onMetadataUpdate,
}: BaseModalProps & {
  metadata: any;
  photoId: number;
  onMetadataUpdate?: (photoId: number, metadata: any) => void;
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      content={
        <div className="modal-window" style={{ width: '1000px' }}>
          <div className="modal-window-top">
            <span className="modal-window-top-title">{'Metadata'}</span>
            <div className="modal-window-top-close" onClick={onClose} />
          </div>
          <div className="modal-window-content metadata-window-content">
            <MetadataEditor
              metadata={metadata}
              photoId={photoId}
              onSave={
                onMetadataUpdate ? newMetadata => onMetadataUpdate(photoId, newMetadata) : undefined
              }
            />
          </div>
        </div>
      }
    />
  );
}

export default MetadataModal;
